import CreateCollectionsContent from 'components/Collection/V2/CreateCollectionsContent'
import { useSAModal } from 'components/SA/Modal'
import React, { forwardRef, useImperativeHandle } from 'react'
import styles from '../CollectionDetails.module.scss'
import { addStoreLocaleByCookie } from 'lib/storeLocale/client'

export type CreateCollectionsModalProps = {
  onSuccess?: (payload: Record<string, any>, formData: Record<string, any>) => void
}

export type CreateCollectionsModalApi = {
  handleOpenModal: () => void
}

export type GetCreatedCollectionUrlParams = {
  payload: Record<string, any>
  formData: Record<string, any>
  userId: string | number
}

export const getCreatedCollectionUrl = ({
  payload,
  formData,
  userId,
}: GetCreatedCollectionUrlParams) => {
  const { data, collection_id } = payload
  const { title } = formData
  const isAASelection = !!collection_id
  const transformedTitle = (title ?? '').replace(/\s+/g, '-')
  const newCollectionPath = `${
    isAASelection ? 'aa-collection/' : ''
  }art-collection/${transformedTitle}/${userId}/${
    isAASelection ? collection_id : data['id_user_collection']
  }/view`

  return addStoreLocaleByCookie(newCollectionPath)
}

const CreateCollectionsModal = forwardRef<
  CreateCollectionsModalApi,
  React.PropsWithChildren<CreateCollectionsModalProps>
>(({ onSuccess }, ref) => {
  const { SAModal, handleOpenModal, handleCloseModal } = useSAModal()

  useImperativeHandle(ref, () => ({
    handleOpenModal,
  }))

  return (
    <SAModal contentStylesClassName={styles.modalContent}>
      <CreateCollectionsContent closeModal={handleCloseModal} onSuccess={onSuccess} />
    </SAModal>
  )
})

export default CreateCollectionsModal
